module.exports = __webpack_public_path__ + "img/acessories.ab31367b.svg";